import { jsxs as h, jsx as i } from "react/jsx-runtime";
import { memo as x, forwardRef as F } from "react";
import { OverLabel as v, StyledMuiTextField as z } from "./styles34.mjs";
import { Stack as L } from "@mui/material";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useFormFieldSize as S } from "./useFormFieldSize.mjs";
import { Typography as y } from "./index59.mjs";
import { InputLabelBase as b } from "./index46.mjs";
const O = x(
  F(
    ({
      variant: p = "outlined",
      fullWidth: t = !0,
      size: f = "small",
      labelType: m = "inside",
      name: r,
      label: o,
      info: c,
      isOptional: d,
      required: e,
      ...n
    }, u) => {
      const s = S(f), l = m === "outside" ? o : void 0, a = m === "inside" && o ? /* @__PURE__ */ i(b, { required: e, isOptional: d, children: o }) : void 0;
      return /* @__PURE__ */ h(
        L,
        {
          display: "inline-flex",
          sx: { width: t ? "100%" : "auto" },
          children: [
            l && /* @__PURE__ */ i(
              v,
              {
                htmlFor: r,
                info: c,
                isOptional: d,
                required: e,
                error: n.error,
                children: /* @__PURE__ */ i(y.Overline, { children: l })
              }
            ),
            /* @__PURE__ */ i(
              z,
              {
                $size: s,
                size: s,
                id: r,
                name: r,
                fullWidth: t,
                label: a,
                inputRef: u,
                variant: p,
                required: e,
                ...n
              }
            )
          ]
        }
      );
    }
  )
);
export {
  O as TextField
};
//# sourceMappingURL=index53.mjs.map
